export default {
  '首页': 'el-HomeFilled',
  '系统管理': 'system-admin',
  '用户管理': 'menu-admin-family',
  '底图管理': 'world-image',
  '区域管理': 'polygon-icon',
  '名录管理': 'polygon-icon',
  '快照任务': 'task-icon',
  '快照管理': 'work-space',
  '快照列表': 'work-space',
  '导出管理': 'file-export',
  '线索区导出': 'download',
}